
import React, { Component } from 'react';
import classnames from 'classnames';
import ModalInner from '../layoutItems/modalInner';
import { withLocalize } from 'react-localize-redux';
import { Translate } from "react-localize-redux";

class RelationsUnlimitedPopup extends Component {
    render() {
        return (
            <ModalInner title={this.props.translate('Report.Common.Warning')}>
                <div className="has-text-centered" style={{ margin: "auto" }}>
                    <p style={{ paddingBottom: "1em" }}>
                        {this.props.message}
                    </p>
                </div>
                <div className="modal-inner-buttons">
                    <button onClick={this.props.close} className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}> <Translate id="Charts.No" /></button>
                    <button onClick={() => { this.props.showNextLevel(this.props.node, this.props.entityIdOnly); this.props.close(); }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}> <Translate id="Charts.Yes" /></button>
                </div>
            </ModalInner >
        )
    }
}
export default withLocalize(RelationsUnlimitedPopup);